module.exports = __webpack_public_path__ + "img/kiriman_penting.9d474e33.svg";